import { __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';

var BaseStockModel =
/** @class */
function (_super) {
  __extends(BaseStockModel, _super);

  function BaseStockModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.uniqueField = 'uuid';
    return _this;
  }

  BaseStockModel.prototype.list = function (query, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = null;
    }

    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getAll(query)];

          case 1:
            request = _a.sent();

            if (request.complete) {
              return [2
              /*return*/
              , this.handleSuccess({
                data: request.data.results,
                total: request.data.total
              }, 'Ok', null, toastConfig)];
            } else {
              this.handleError(request, toast, toastConfig);
              return [2
              /*return*/
              , {
                data: [],
                total: 0
              }];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseStockModel.prototype.get = function (query, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var id, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            id = query.query.filters.uuid;
            return [4
            /*yield*/
            , this.service.getBy({
              id: id
            })];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, response.message, toast, toastConfig)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseStockModel.prototype.create = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var query, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            query = {
              query: data,
              method: 'POST'
            };
            return [4
            /*yield*/
            , this.service.insert(query)];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, 'Ok', null)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  }; //
  // public async update(data, toast: any = null, toastConfig: any = {}) {
  //   const {id} = this.request === 'JSON' ? JSON.parse(data) : {id: (data as FormData).get('id')};
  //   const query = {
  //     query: data,
  //     method: 'PUT',
  //     id,
  //   };
  //   const response = await this.service.update(query as GenericMethod);
  //   if (response.complete) {
  //     return this.handleSuccess(response, 'Ok', null);
  //   } else {
  //     this.handleError(response, toast, toastConfig);
  //     return false;
  //   }
  // }


  BaseStockModel.prototype.delete = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var query, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            query = {
              id: data,
              method: 'DELETE'
            };
            return [4
            /*yield*/
            , this.service.deleteBy(query)];

          case 1:
            response = _a.sent();

            if (response.uuid) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, response.message, null)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return BaseStockModel;
}(BaseModel);

export { BaseStockModel };